import React from 'react'
import { ClaimStatusFooter, ClaimstatusForm, ClaimstatusHeader } from '../../components'
import './claimstatus.scss'
const ClaimStatus = () => {
  return (
    <div className='claimstatus-wrapped'>
      <ClaimstatusHeader/>
      <div className='claim-status-body'>
        <ClaimstatusForm/>
      </div>
      <ClaimStatusFooter/>
    </div>
  )
}

export default ClaimStatus
